import { FC } from 'react';

import { Icon, LinkButton, LinkButtonProps } from '@eluve/components';

type OpenInAppButtonProps = {
  appointmentId: string;
  tenantId: string;
  size?: LinkButtonProps['size'];
};

export const OpenInAppButton: FC<OpenInAppButtonProps> = ({
  appointmentId,
  tenantId,
  size,
}) => {
  const url = `/organizations/${tenantId}/appointments/${appointmentId}`;

  return (
    <LinkButton variant="outline" size={size} to={url}>
      <Icon name="AppWindow" size="auto" />
      Open in App
    </LinkButton>
  );
};
